import React, { Children, cloneElement, FC, type MouseEvent, ReactElement, type ReactNode, useContext } from 'react';
import { DropdownContext } from './DropdownContext';

/**
 * DropdownMenuTrigger Props Interface.
 */
export interface DropdownMenuTriggerProps {
    children: ReactNode;
}

/**
 * The trigger element which toggles the dropdown.
 * It expects a single React element as its child.
 */
export const DropdownMenuTrigger: FC<DropdownMenuTriggerProps> = props => {
    const { children } = props;

    const context = useContext(DropdownContext);
    if (!context) throw new Error('DropdownMenuTrigger must be used within a DropdownMenu component.');

    const { open, setOpen, triggerRef } = context;

    const handleClick = (e: MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        e.preventDefault();
        setOpen(!open);
    };

    // Clone the child to inject our props (ref and onClick)
    return cloneElement(Children.only(children) as ReactElement<any>, {
        ref: triggerRef,
        onClick: handleClick,
    });
};
